import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { loadContent } from "@/lib/api";
import { DEFAULT_CONFIG, FALLBACK_VILLAS, FALLBACK_REVIEWS } from "@/lib/content";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Story } from "@/components/Story";
import { Villas } from "@/components/Villas";
import { WhyUs } from "@/components/WhyUs";
import { Experiences } from "@/components/Experiences";
import { Reviews } from "@/components/Reviews";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";
import Admin from "@/pages/Admin";

function Home() {
  const [content, setContent] = useState({
    config: DEFAULT_CONFIG,
    villas: FALLBACK_VILLAS,
    reviews: FALLBACK_REVIEWS,
  });

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    loadContent().then(setContent);
  }, []);

  return (
    <div className="grain bg-ivory font-sans text-ink" data-testid="app-root">
      <Header config={content.config} />
      <main>
        <Hero config={content.config} />
        <Marquee />
        <Story />
        <Villas villas={content.villas} config={content.config} />
        <WhyUs />
        <Experiences />
        <Reviews reviews={content.reviews} />
        <FinalCTA config={content.config} />
      </main>
      <Footer />
      <StickyBar config={content.config} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
